import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from '../../services/api.service';
import { JobService } from '../../services/job.service.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SitemapComponent } from 'src/app/shared/sitemap/sitemap.component';

@Component({
  selector: 'app-job-trusted',
  templateUrl: './app-job-trusted.component.html',
  styleUrls: ['./app-job-trusted.component.scss'],
  standalone: false,
})
export class JobTrustedComponent implements OnInit {
  eventData: any = [];
  canShare = false;
  emailId = 'team@inforida.com';
  logoUrl: any;
  infiniteSlide = true;
  imageSize = {
    width: '80px',
    height: '80px',
    space: 12,
  };
  autoSlide = { interval: 1, stopOnHover: true };

  constructor(
    public apiService: APIService,
    public jobService: JobService,
    private router: Router,
    private title: Title,
    private meta: Meta,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private deviceDetectorService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    console.log('router', this.router.url);
    this.getLogo();
  }

  getLogo() {
    this.apiService.getSchoolLogo().subscribe((res: any) => {
      this.logoUrl = res;
    });
    if (this.logoUrl.length) {
      let thumbSize = 'h_280,w_360';
      let finalSize = 'h_800';

      this.logoUrl = this.logoUrl.map((img: any) => {
        img.thumbImage = this.transformImageSize(img.url, thumbSize);
        img.image = this.transformImageSize(img.url, finalSize);
        img.alt = '';
        img.title = '';
        return img;
      });
      // console.log('this.school.gallery after ', this.school.gallery);
    }
  }

  transformImageSize(url, size) {
    if (url && url.length && url.includes('cloudinary')) {
      const urlSplit = url.split('/upload/');
      return `${urlSplit[0]}/upload/${size}/${urlSplit[1]}`;
    }
    return url;
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile();
  }
}
